import { mapRegionToCustomCode, regionCustomCodeMap, UserRegionType } from '../mapper/mapRegionToCustomCode';

export const RegionDepth = {
  REGION: 1, // 시/도
  DISTRICT: 2, // 시/군/구
} as const;

type RegionDepthType = (typeof RegionDepth)[keyof typeof RegionDepth];

const formatRegionName = (regionCode: string): string => {
  switch (regionCode) {
    case regionCustomCodeMap.강원특별자치도:
      return '강원';
    case regionCustomCodeMap.전북특별자치도:
      return '전북';
    case regionCustomCodeMap.전라남도:
      return '전남';
    case regionCustomCodeMap.세종특별자치시:
      return '세종';
    case regionCustomCodeMap.제주특별자치도:
      return '제주';
    default:
      return '';
  }
};

export const getRegionByDepth = (address: string, depth: RegionDepthType): string => {
  if (!address) {
    return '';
  }

  const addressParts = address.split(' ');
  const regionDepth1: UserRegionType = addressParts[0] as UserRegionType;
  const regionCode = mapRegionToCustomCode({ regionDepth1 });
  const formattedRegion = formatRegionName(regionCode);

  if (depth === RegionDepth.REGION) {
    return formattedRegion || addressParts[0];
  }

  const districtParts = addressParts.slice(0, depth);
  if (formattedRegion) {
    districtParts[0] = formattedRegion;
  }

  return districtParts.join(' ');
};

export const getShortRegionAddress = (address: string): string => {
  if (!address) {
    return '';
  }

  const addressParts = address.split(' ');
  const regionDepth1: UserRegionType = addressParts[0] as UserRegionType;
  const regionCode = mapRegionToCustomCode({ regionDepth1 });
  const formattedRegion = formatRegionName(regionCode);

  const shortRegionName = formattedRegion || addressParts[0];

  const result = [shortRegionName, ...addressParts.slice(1)].join(' ');

  return result;
};
